<template>
  <div class="share-page" :class="{ 'dark-theme': isDarkTheme }">
    <!-- 移动端导航栏 -->
    <div class="mobile-header">
      <div class="logo" @click="goToHomepage">
        <img :src="logo1" alt="EasyNoteAI Logo" />
      </div>
      <!-- 在iOS设备上显示App Store链接 -->
      <a v-if="isIosDevice" href="https://apps.apple.com/us/app/easynoteai-ai-note-taker/id6739731914" target="_blank"
        class="app-store-link">
        <i class="el-icon-apple"></i>
        <span>App Store</span>
      </a>
      <div class="mobile-theme-toggle-header" @click="toggleTheme">
        <i :class="isDarkTheme ? 'el-icon-sunny' : 'el-icon-moon'"></i>
      </div>
    </div>

    <!-- 移动端平铺菜单 -->
    <div class="mobile-top-menu" v-if="isMobileView">
      <ul class="mobile-nav-items-horizontal">
        <li :class="{ active: noteasidekey == 'notes' }" @click="chooseaside('notes')">Notes</li>
        <li :class="{ active: noteasidekey == 'mindmap' }" @click="chooseaside('mindmap')">Mind Map</li>
        <li :class="{ active: noteasidekey == 'transcript' }" @click="chooseaside('transcript')">Transcript</li>
      </ul>
    </div>

    <div class="content-container">
      <!-- 桌面端侧边栏 -->
      <aside class="sidebar">
        <div class="logo" @click="goToHomepage">
          <img :src="logo1" alt="EasyNoteAI Logo" />
        </div>
        <ul class="nav-items">
          <li :class="{ active: noteasidekey == 'notes' }" @click="chooseaside('notes')">
            <i class="el-icon-notebook-1"></i>
            Notes
          </li>
          <li :class="{ active: noteasidekey == 'mindmap' }" @click="chooseaside('mindmap')">
            <i class="el-icon-connection"></i>
            Mind Map
          </li>
          <li :class="{ active: noteasidekey == 'transcript' }" @click="chooseaside('transcript')">
            <i class="el-icon-document"></i>
            Transcript
          </li>
        </ul>

        <!-- 主题切换按钮 -->
        <div class="theme-toggle" @click="toggleTheme">
          <i :class="isDarkTheme ? 'el-icon-sunny' : 'el-icon-moon'"></i>
          <span>{{ isDarkTheme ? 'Light Mode' : 'Dark Mode' }}</span>
        </div>
      </aside>

      <!-- 主内容区 -->
      <main class="main-content">
        <div class="content-header" v-if="noteobj.notename">
          <div class="content-title">
            <h1>{{ noteobj?.notename }}</h1>
            <div class="content-metadata">
              <span class="date">{{ formatDateTime(noteobj?.createtime) }}</span>
              <button class="share-button" @click="noteshare()">
                <i class="el-icon-share"></i>
                Share
              </button>
            </div>
          </div>
        </div>

        <div class="content-body" :class="{ 'loading': noteobj.status === 0 || noteobj.status === -1 }">
          <div v-if="noteobj.status === 0 || noteobj.status === -1" class="loading-container">
            <div class="loading-spinner"></div>
            <p>Loading note content...</p>
          </div>

          <div v-else-if="noteobj.status === 3" class="error-container">
            <i class="el-icon-warning-outline"></i>
            <p>Note generation failed. Please try again later.</p>
          </div>

          <div v-else class="scrollable-content">
            <div class="notes-container" v-if="noteasidekey == 'notes'" :class="{ 'with-translate': showTranslate }">
              <sharenotes v-bind:noteobj="noteobj" v-if="noteasidekey == 'notes'" @toggleTranslate="toggleTranslate" />
              <TranslateToggle v-if="showTranslate" :notupdate="true" :noteobj="noteobj" />
            </div>
            <sharemindmap v-bind:noteobj="noteobj" v-if="noteasidekey == 'mindmap'" />
            <sharetranscript v-bind:transcript="transcript" v-if="noteasidekey == 'transcript'" />
            <notechatbot v-bind:noteobj="noteobj" v-if="noteasidekey == 'chatbot'" />
            <noteflashcards v-bind:noteobj="noteobj" v-if="noteasidekey == 'flashcards'" />
            <notequiz v-bind:questionsI="questionsI" v-if="noteasidekey == 'quiz'" />
            <notesetting v-bind:noteobj="noteobj" v-if="noteasidekey == 'settings'" />
          </div>
        </div>
      </main>
    </div>

    <div class="share-success-toast" v-show="showShareToast">Link copied to clipboard!</div>
    <notechangetitle ref="pchangetitle" />
  </div>
</template>

<script>
import sharenotes from "@/views/pages/components/share_notes.vue";
import notechatbot from "@/views/pages/components/note_chatbot.vue";
import noteflashcards from "@/views/pages/components/note_flashcards.vue";
import notequiz from "@/views/pages/components/note_quiz.vue";
import sharetranscript from "@/views/pages/components/share_transcript.vue";
import notesetting from "@/views/pages/components/note_settting.vue";
import notechangetitle from "@/views/pages/components/popups/popup_changetitle.vue";
import sharemindmap from "@/views/pages/components/share_mindmap.vue";
import TranslateToggle from "@/views/pages/components/translate_toggle.vue";
export default {
  components: {
    sharenotes,
    sharemindmap,
    sharetranscript,
    notechatbot,
    noteflashcards,
    notequiz,
    notesetting,
    notechangetitle,    
    TranslateToggle,
  },
  name: "ShareIndexPage",
  data() {
    return {
      noteasidekey: "notes",
      logo: require("../assets/images/index/logo.png"),
      logo1: require("../assets/images/index/logo1.png"),
      noteobj: { status: -1 },
      questionsI: [],
      transcript: {},
      timer: null,
      email: "",
      notclick: 0,
      showTranslate: false,
      mobileMenuOpen: false,
      showShareToast: false,
      isDarkTheme: false, // 默认使用浅色主题
      isMobileView: false,
      isIosDevice: false, // 是否是iOS设备
    };
  },
  watch: {
    noteasidekey() {
      this.$nextTick(() => {
        const mainContent = document.querySelector(".main-content");
        if (mainContent) {
          mainContent.scrollTop = 0;
        }
      });

      // 在移动端自动关闭菜单
      if (this.mobileMenuOpen) {
        this.toggleMobileMenu();
      }
    },
    isDarkTheme: {
      handler(newVal) {
        // 保存用户主题偏好到localStorage
        localStorage.setItem('easynote-theme-preference', newVal ? 'dark' : 'light');
        // 通知子组件主题已更改 - 使用直接调用方式
        this.$nextTick(() => {
          // 通知所有子组件主题变更
          this.$children.forEach(child => {
            if (child.onThemeChange && typeof child.onThemeChange === 'function') {
              child.onThemeChange(newVal);
            }
          });
        });
      }
    }
  },
  mounted() {
    // 添加视口元标签来支持iOS安全区域
    this.addViewportMeta();

    this.chooseaside('notes');
    if (this.$route.query && this.$route.query.t) {
      const token = this.$route.query.t;
      this.getnotestoken(token);
    }

    // 检测是否为移动视图
    this.isMobileView = window.innerWidth <= 768;

    // 添加响应式处理
    window.addEventListener('resize', this.handleResize);
    this.handleResize();

    // 在移动端视图中禁止body滚动
    this.updateMobileScroll();

    // 加载用户的主题偏好
    const savedTheme = localStorage.getItem('easynote-theme-preference');
    if (savedTheme) {
      this.isDarkTheme = savedTheme === 'dark';
    } else {
      // 可选：检测系统主题偏好
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.isDarkTheme = false;
      }
    }

    // 检测是否是iOS设备
    this.detectIosDevice();
  },
  methods: {
    // 添加支持iOS安全区域的视口meta标签
    addViewportMeta() {
      let meta = document.querySelector('meta[name="viewport"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'viewport';
        document.head.appendChild(meta);
      }
      meta.content = 'width=device-width, initial-scale=1.0, viewport-fit=cover';
    },
    handleResize() {
      // 检测是否为移动视图
      const wasMobile = this.isMobileView;
      this.isMobileView = window.innerWidth <= 768;

      // 如果移动状态发生变化，更新滚动设置
      if (wasMobile !== this.isMobileView) {
        this.updateMobileScroll();
      }
    },
    updateMobileScroll() {
      if (this.isMobileView) {
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.height = '100%';

        // 为iOS设备添加额外的视觉调整
        if (this.isIosDevice) {
          document.body.style.paddingBottom = 'env(safe-area-inset-bottom, 0)';
          document.documentElement.style.height = '-webkit-fill-available';
        }
      } else {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.height = '';
        document.body.style.paddingBottom = '';
        document.documentElement.style.height = '';
      }
    },
    toggleMobileMenu() {
      // 空方法，保留以防其他地方调用
    },
    goToHomepage() {
      window.location.href = 'https://www.easynoteai.com';
    },
    toggleTranslate(isopen = null) {
      if (this.noteobj.note_translate && isopen) {
        this.showTranslate = true;
      } else {
        this.showTranslate = false;
      }
    },
    openchangetitle() {
      this.$refs.pchangetitle.openModal();
    },
    async getnotestoken(token, status = 0) {
      if (status == 10) {
        this.noteobj.status = 0;
      }
      try {
        const respne = await this.$axios.post("api/getnotestoken/", {
          token: token,
        });
        const redata = respne.data;
        if (redata.code == 200) {
          this.noteobj = redata.noteobj;
          this.noteobj.status = 1;
          clearInterval(this.timer);
        }
        else if (redata.code == 201) {
          // 显示为加载状态，而非立即显示错误
          this.noteobj.status = 0;

          // 3秒后尝试重新加载
          if (!this.timer) {
            this.timer = setInterval(() => {
              this.getnotestoken(token, 10);
            }, 3000);
          }

          // 最多尝试5次，避免无限循环
          this.notclick++;
          if (this.notclick > 5) {
            this.$message({
              center: true,
              message: "The note does not exist",
              type: "warning",
            });
            clearInterval(this.timer);
          }
        }
        else if (redata.code == 202) {
          this.noteobj.status = 0;

          // 如果是创建中状态，定时轮询
          if (!this.timer) {
            this.timer = setInterval(() => {
              this.getnotestoken(token, 10);
            }, 3000);
          }
        }
        else if (redata.code == 203) {
          // 显示为加载状态，而非立即显示错误
          this.noteobj.status = 0;

          // 3秒后尝试重新加载
          if (!this.timer) {
            this.timer = setInterval(() => {
              this.getnotestoken(token, 10);
            }, 3000);
          }

          // 最多尝试5次，避免无限循环
          this.notclick++;
          if (this.notclick > 5) {
            this.noteobj = redata.noteobj;
            this.$message({
              center: true,
              message: "Note generation failed",
              type: "error",
            });
            this.noteobj.status = 3;
            clearInterval(this.timer);
          }
        }
      } catch (error) {
        // 显示为加载状态，而非立即显示错误
        this.noteobj.status = 0;

        // 3秒后尝试重新加载
        if (!this.timer) {
          this.timer = setInterval(() => {
            this.getnotestoken(token, 10);
          }, 3000);
        }

        // 最多尝试5次，避免无限循环
        this.notclick++;
        if (this.notclick > 5) {
          clearInterval(this.timer);
          console.log("error", error);
        }
      }
    },
    chooseaside(key) {
      this.noteasidekey = key;
      switch (key) {
        case "notes":
          // 切换到notes页面时，通知子组件当前主题状态
          this.$nextTick(() => {
            this.$children.forEach(child => {
              if (child.onThemeChange && typeof child.onThemeChange === 'function') {
                child.onThemeChange(this.isDarkTheme);
              }
            });
          });
          break;
        case "mindmap":
          break;
        case "chatBot":
          break;
        case "flashcards":
          break;
        case "quiz":
          this.questionsI = this.noteobj.note_quiz;
          for (let i = 0; i < this.questionsI.length; i++) {
            this.$set(this.questionsI[i], "ischooes", false);
            this.$set(this.questionsI[i], "chooese", -1);
          }
          break;
        case "transcript":
          if (this.noteobj.filetype == 'record') {
            if (this.noteobj?.live_transcript?.text_objs) {
              this.transcript["value"] = this.noteobj?.live_transcript;
              this.transcript["notetoken"] = this.noteobj?.notetoken;
            } else {
              this.transcript["value"] = this.noteobj?.live_transcript;
              this.transcript["notetoken"] = this.noteobj?.notetoken;
            }
          } else {
            this.transcript["value"] = this.noteobj?.note_transcript;
            this.transcript["notetoken"] = this.noteobj?.notetoken;
          }
          this.transcript["type"] = this.noteobj.filetype;

          // 切换到transcript页面时，通知子组件当前主题状态
          this.$nextTick(() => {
            this.$children.forEach(child => {
              if (child.onThemeChange && typeof child.onThemeChange === 'function') {
                child.onThemeChange(this.isDarkTheme);
              }
            });
          });
          break;
        case "settings":
          break;
        default:
          break;
      }
    },
    formatDateTime(dateTime) {
      if (!dateTime) return "";
      const date = new Date(dateTime);
      const options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      };
      return date.toLocaleString("en-US", options);
    },
    noteshare() {
      const shareurl = window.location.origin + '/share?t=' + this.noteobj.notetoken;
      this.copyToClipboard(shareurl);
    },
    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(() => {
          this.showShareToast = true;
          setTimeout(() => {
            this.showShareToast = false;
          }, 3000);
        }).catch((err) => {
          console.error('Could not copy text: ', err);
        });
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this.showShareToast = true;
          setTimeout(() => {
            this.showShareToast = false;
          }, 3000);
        } catch (err) {
          console.error('Could not copy text: ', err);
        }
        document.body.removeChild(textArea);
      }
    },
    toggleTheme() {
      this.isDarkTheme = !this.isDarkTheme;
      // 立即通知子组件主题已更改
      this.$nextTick(() => {
        this.$children.forEach(child => {
          if (child.onThemeChange && typeof child.onThemeChange === 'function') {
            child.onThemeChange(this.isDarkTheme);
          }
        });
      });
    },
    detectIosDevice() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      this.isIosDevice = /iphone|ipad|ipod/.test(userAgent) ||
        (userAgent.includes('mac') && 'ontouchend' in document);
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener('resize', this.handleResize);

    // 移除移动端视图中添加的样式
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.height = '';
    document.body.style.paddingBottom = '';
    document.documentElement.style.height = '';
  },
};
</script>

<style lang="less" scoped>
/* 主题变量 */
.share-page {
  --primary-color: #4a6bff;
  --primary-light: #eef1ff;
  --secondary-color: #9ba3eb;
  --text-color: #333333;
  --text-light: #666666;
  --background-color: #ffffff;
  --background-light: #f8f9fa;
  --border-color: #e6e8ed;
  --success-color: #34c759;
  --error-color: #ff3b30;
  --shadow-color: rgba(0, 0, 0, 0.08);
  --toast-bg-color: rgba(51, 51, 51, 0.9);

  &.dark-theme {
    --primary-color: #5d6fff;
    --primary-light: #232748;
    --secondary-color: #9ba3eb;
    --text-color: #f0f0f0;
    --text-light: #aaaaaa;
    --background-color: #1a1a1a;
    --background-light: #2a2a2a;
    --border-color: #3a3a3a;
    --success-color: #34c759;
    --error-color: #ff3b30;
    --shadow-color: rgba(0, 0, 0, 0.3);
    --toast-bg-color: rgba(255, 255, 255, 0.9);
  }

  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: 'Inter',
  -apple-system,
  BlinkMacSystemFont,
  'Segoe UI',
  Roboto,
  Oxygen,
  Ubuntu,
  Cantarell,
  sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  transition: all 0.3s ease;
}

/* 主题切换按钮 */
.theme-toggle {
  margin-top: auto;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  border-top: 1px solid var(--border-color);

  i {
    font-size: 20px;
    margin-right: 12px;
    color: var(--primary-color);
  }

  span {
    color: var(--text-color);
    font-size: 14px;
  }

  &:hover {
    background-color: var(--background-light);
  }
}

.mobile-theme-toggle {
  display: none;
  position: fixed;
  bottom: 40px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: var(--primary-color);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 10px var(--shadow-color);
  z-index: 99;
  transition: all 0.3s;

  i {
    font-size: 24px;
  }

  &:hover {
    transform: scale(1.05);
  }
}

/* 移动端导航 */
.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 60px;
  padding: 0 20px;
  background-color: var(--background-color);
  box-shadow: 0 2px 10px var(--shadow-color);
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.mobile-theme-toggle-header {
  font-size: 24px;
  cursor: pointer;
  color: var(--text-color);
}

.mobile-top-menu {
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  width: 100%;
  background-color: var(--background-color);
  z-index: 101;
  box-shadow: 0 2px 5px var(--shadow-color);
  transition: all 0.3s ease;
}

.mobile-nav-items-horizontal {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-around;
  width: 100%;
  border-bottom: 1px solid var(--border-color);
  background-color: var(--background-color);
}

.mobile-nav-items-horizontal li {
  padding: 15px 5px;
  cursor: pointer;
  text-align: center;
  flex: 1;
  border-bottom: 2px solid transparent;
  transition: all 0.2s;
  color: var(--text-color);
  font-size: 14px;
}

.mobile-nav-items-horizontal li.active {
  border-bottom: 2px solid var(--primary-color);
  color: var(--primary-color);
  font-weight: 500;
  background-color: transparent;
}

.mobile-nav-items-horizontal li:hover {
  background-color: var(--background-light);
}

.mobile-menu-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
}

/* 内容容器 */
.content-container {
  display: flex;
  flex: 1;
  position: relative;
}

/* 侧边栏 */
.sidebar {
  width: 240px;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: var(--background-color);
  box-shadow: 2px 0 10px var(--shadow-color);
  z-index: 10;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.logo {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid var(--border-color);
  height: 60px;
}

.logo img {
  height: 36px;
  max-width: 100%;
}

.nav-items {
  list-style: none;
  padding: 20px 0;
  margin: 0;
}

.nav-items li {
  padding: 12px 25px;
  margin: 5px 15px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s;
  color: var(--text-color);
}

.nav-items li i {
  margin-right: 12px;
  font-size: 18px;
  color: var(--text-light);
}

.nav-items li.active {
  background-color: var(--primary-light);
  color: var(--primary-color);
  font-weight: 500;
}

.nav-items li.active i {
  color: var(--primary-color);
}

.nav-items li:hover:not(.active) {
  background-color: var(--background-light);
}

/* 主内容区 */
.main-content {
  flex: 1;
  margin-left: 240px;
  min-height: 100vh;
  position: relative;
  overflow-y: auto;
  background-color: var(--background-color);
  color: var(--text-color);
  transition: all 0.3s ease;
}

.content-header {
  background-color: var(--background-color);
  padding: 10px 40px;
  border-bottom: 1px solid var(--border-color);
  box-shadow: 0 2px 10px var(--shadow-color);
  transition: all 0.3s ease;
}

.content-title {
  display: flex;
  flex-direction: column;
}

.content-title h1 {
  margin: 0 0 10px 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease;
}

.content-metadata {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.date {
  color: var(--text-light);
  font-size: 14px;
  transition: color 0.3s ease;
}

.share-button {
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.share-button i {
  margin-right: 8px;
}

.share-button:hover {
  background-color: #3955d1;
}

.content-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 7px 15px;
  // padding-bottom: 200px !important; /* 显著增加底部间距 */
  height: auto !important;
  /* 自动高度 */
  min-height: calc(100% - 150px);
  /* 使用最小高度而非固定高度 */
}

/* 笔记内容容器 */
.notes-container {
  display: flex;
  width: 100%;
  transition: all 0.3s ease;
  position: relative;
}

.notes-container.with-translate {
  gap: 20px;
}

/* 加载状态 */
.loading-container,
.error-container,
.not-found-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  text-align: center;
  padding: 30px;
  color: var(--text-color);
  transition: color 0.3s ease;
}

.loading-container p,
.error-container p,
.not-found-container p {
  color: var(--text-color);
  font-size: 16px;
  transition: color 0.3s ease;
  margin-top: 15px;
  font-weight: 500;
}

.loading-spinner {
  width: 50px;
  /* 稍微增大尺寸 */
  height: 50px;
  border: 5px solid var(--background-light);
  border-top: 5px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1.2s linear infinite;
  margin-bottom: 15px;
  transition: border-color 0.3s ease;
  box-shadow: 0 0 10px var(--shadow-color);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* 添加一个加载提示文字的动画效果 */
.loading-container p::after {
  content: '';
  display: inline-block;
  animation: dots 1.5s infinite;
  width: 12px;
  text-align: left;
}

@keyframes dots {
  0% {
    content: '';
  }

  25% {
    content: '.';
  }

  50% {
    content: '..';
  }

  75% {
    content: '...';
  }

  100% {
    content: '';
  }
}

.error-container i,
.not-found-container i {
  font-size: 40px;
  color: var(--error-color);
  margin-bottom: 15px;
  transition: color 0.3s ease;
}

/* 分享成功提示 */
.share-success-toast {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--toast-bg-color);
  color: var(--background-color);
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 16px;
  z-index: 1000;
  animation: fadeInOut 3s ease;
  transition: background-color 0.3s ease, color 0.3s ease;
}

@keyframes fadeInOut {

  0%,
  100% {
    opacity: 0;
  }

  10%,
  90% {
    opacity: 1;
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  body {
    overflow: hidden;
    position: fixed;
    width: 100%;
    height: 100%;
  }

  .share-page {
    height: 100vh;
    overflow: hidden;
    padding-bottom: env(safe-area-inset-bottom, 0);
    /* 适配iPhone安全区域 */
  }

  .mobile-header {
    display: flex;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 200;
    padding-top: env(safe-area-inset-top, 0);
    /* 适配iPhone安全区域 */
  }

  .mobile-top-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    z-index: 200;
  }

  .sidebar {
    display: none;
  }

  .content-container {
    height: 100vh;
    overflow: hidden;
  }

  .main-content {
    margin-left: 0;
    margin-top: 110px;
    /* 60px头部 + 50px菜单 */
    height: calc(100vh - 110px - env(safe-area-inset-bottom, 0) - 60px);
    /* 减去底部浏览器UI的高度 */
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .content-header {
    padding: 15px;
    background-color: var(--background-color);
    z-index: 100;
    box-shadow: 0 2px 5px var(--shadow-color);
    flex-shrink: 0;
  }

  .content-body {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0 15px;
    height: auto !important;
    /* 自动高度 */
    min-height: calc(100% - 100px);
    /* 使用最小高度而非固定高度 */
  }

  .scrollable-content {
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    height: auto !important;
    /* 自动高度 */
    min-height: 100%;
    /* 使用最小高度 */
  }

  .content-title h1 {
    font-size: 20px;
  }

  .share-button {
    padding: 8px 16px;
    font-size: 15px;
  }

  .notes-container.with-translate {
    flex-direction: column;
  }

  .share-success-toast {
    font-size: 16px;
    padding: 14px 24px;
    border-radius: 10px;
    z-index: 300;
    bottom: calc(30px + env(safe-area-inset-bottom, 0));
    /* 调整底部距离 */
  }

  .date {
    font-size: 15px;
  }

  .mobile-theme-toggle {
    display: none;
  }

  .app-store-link {
    padding: 4px 10px;
    border-radius: 14px;

    i {
      font-size: 14px;
    }

    span {
      font-size: 12px;
    }
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .sidebar {
    width: 200px;
  }

  .main-content {
    margin-left: 200px;
  }

  .content-body {
    padding: 15px 30px;
  }
}

.scrollable-content {
  width: 100%;
  height: 100%;
}

/* App Store链接样式 */
.app-store-link {
  display: flex;
  align-items: center;
  color: var(--background-color);
  text-decoration: none;
  margin-right: 15px;
  padding: 6px 12px;
  border-radius: 16px;
  background-color: var(--primary-color);
  transition: all 0.3s;
  box-shadow: 0 2px 8px rgba(74, 107, 255, 0.3);

  i {
    margin-right: 6px;
    font-size: 16px;
  }

  span {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.2px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(74, 107, 255, 0.4);
  }

  .dark-theme & {
    background-color: #5d6fff;
    box-shadow: 0 2px 8px rgba(93, 111, 255, 0.4);

    &:hover {
      box-shadow: 0 4px 12px rgba(93, 111, 255, 0.6);
    }
  }
}
</style>